// 为钉钉静态中间页面创建
<template>
  <el-container>
    <el-header class="my-el-header">
      <div class="header">
        <el-row type="flex">
          <el-col :span="3" class="jzq-logo">
            <img src="/images/logo/jzq-logo.png" alt />
          </el-col>
          <!--导航菜单-->
          <el-col :span="15">
            <nav>
              <ul>
                <li class="active">
                  <span class="item">首页</span>
                </li>
                <li>
                  <span class="item">文件管理</span>
                </li>
                <li style="cursor: pointer">
                  <div class="item">司法服务</div>
                </li>
              </ul>
            </nav>
          </el-col>
          <!--右侧用户弹出窗-->
          <el-col :span="6" style="padding-left: 20px; box-sizing: border-box"></el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <nuxt />
    </el-main>
  </el-container>
</template>

<script>
import MyFooter from "@/components/myfooter/index.vue";

export default {
  name: "defaultStatic",
  data () {
    return {
    };
  },
  mounted () {
  },
  components: {
  }
};
</script>

<style lang="less" scoped>
.el-main {
  /*max-width: 1200px;*/
  max-width: 1366px;
  margin: 0 auto;
  width: 100%;
}

.header {
  /*max-width: 1366px;*/
  max-width: 1326px;
  margin: 0 auto;

  .jzq-logo {
    height: 60px;
    line-height: 60px;
  }

  .profile-mini {
    position: relative;
    z-index: 10;
    line-height: 60px;
    height: 60px;
    margin-left: 26px;
    max-width: 200px;
    text-align: right;

    .top-profile {
      display: inline-block;
      position: relative;
      width: 100%;
      margin-left: -22px;
      line-height: 60px;
      height: 60px;
      white-space: nowrap;
      cursor: pointer;
    }

    a {
      position: relative;
      max-width: 100%;
      padding: 0 0 0 22px;
      margin-left: -22px;
      z-index: 1;
      display: inline-block;
      color: #cccccc;

      .name {
        display: inline-block;
        vertical-align: middle;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .profile-down {
        margin-top: -3px;
        font-size: 20px;
        color: #cccccc;
        transition: all 0.3s;
        vertical-align: middle;
      }
    }

    .el-icon-arrow-right {
      font-size: 16px;
      transition: all 0.2s linear;
      vertical-align: middle;
      margin-bottom: 2px;
      margin-left: 15px;
    }

    img {
      margin-right: 10px;
    }

    &:hover {
      .profile-down {
        transform: rotate(-90deg);
      }

      .profile-expand {
        width: 130%;
        /*z-index: 2;*/
        transform: translateY(0);
        opacity: 1;
      }

      .el-icon-arrow-right {
        transform: rotate(90deg);
      }
    }

    /deep/ .change-account .d-box {
      max-width: 160px;
    }

    /deep/ .profile-expand {
      transition: all 0.3s;
      margin-left: -20px;
      position: absolute;
      opacity: 0;
      top: 60px;
      z-index: -1;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
      left: 2px;
      background-color: #ffffff;
      transform: translateY(-100%);
      color: #000000;
      width: 130%;

      .search-profile {
        position: absolute;
        background-color: #ffffff;
        padding: 0 20px;
        border-bottom: solid 1px #ddd;
      }

      .wrap {
        overflow-y: auto;
        max-height: 420px;
      }

      li {
        border-bottom: solid 1px #ddd;
        padding: 10px 80px 10px 10px;
        transition: all 0.5s;

        .current-user {
          right: 15px;
        }
      }
    }

    .photo {
      max-width: 30px;
      max-height: 30px;
      border-radius: 50%;
      /*border: solid 1px #696969;*/
    }
  }

  .user-sider {
    .header-usr {
      position: relative;
      width: 100%;
      padding-right: 16px;
      display: inline-block;
      height: 66px;
      line-height: 66px;
      font-size: 15px;
      color: #cccccc;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;

      img {
        width: 36px;
        height: 36px;
        margin-right: 5px;
        border-radius: 50%;
        cursor: pointer;
      }

      a {
        color: #fff;
      }

      .profile-down {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -10px;
        font-size: 20px;
        color: #cccccc;
      }
    }
  }

  nav {
    width: 100%;
    height: 60px;
    // overflow: hidden;

    ul {
      float: right;

      li.active .item {
        background: rgba(255, 255, 255, 0.31);
      }

      li {
        float: left;
        cursor: pointer;

        .item {
          display: inline-block;
          width: 130px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          color: #ffffff;

          &.console {
            background-color: #ec1c1c;
            color: #fff;
            display: inline-block;
            margin-left: 30px;
            height: 26px;
            line-height: 26px;
            margin-top: 17px;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;

            &:hover {
              background-color: #d60000;
              color: #fff;
            }
          }
        }

        .item:hover {
          /*color: red;*/
          background: rgba(255, 255, 255, 0.31);
        }
      }
    }
  }

  .jzq-logo {
    img {
      width: 176%;
    }
  }

  .logout {
    position: absolute;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    right: 5px;
    top: 0;
    z-index: 10;
    color: #cccccc;
    white-space: nowrap;
    display: flex;
    align-items: center;

    div {
      width: 20px;
      height: 20px;
      background: url("../static/images/logout.png") no-repeat;
      background-size: cover;
      margin-right: 5px;
    }

    &:hover {
      color: red;

      div {
        background: url("../static/images/logoutHover.png") no-repeat;
        background-size: cover;
      }
    }
  }
}

.my-el-header {
  width: 100%;
  z-index: 500;
  height: 60px !important;
  background-color: #ec1c1c;
  color: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(38, 38, 38, 0.35);
  transition: all ease-in 0.2s;
}

.user-content {
  position: absolute;
  top: -30px;
  background: #ffffff;
  width: 70%;
  left: 0;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .footer {
    background-color: #f0f0f0;
    padding: 0 12px;

    .logout {
      text-align: right;
    }

    .sign .hasSign {
      text-align: left;
    }

    span {
      display: inline-block;
      margin-left: 10px;
      line-height: 38px;
      color: #525250;
      cursor: pointer;
    }

    .hasSign {
      span {
        color: #aaaaaa;
        cursor: default;
      }
    }
  }

  .nav-list {
    span {
      cursor: pointer;
    }

    .icon {
      max-width: 20px;
      max-height: 20px;
      vertical-align: top;
      margin-top: 5px;
      margin-right: 10px;
    }
  }

  .user-name {
    width: 90px;
    margin: 0 auto;
    text-align: center;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .img {
    text-align: center;
    margin-top: -40px;

    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
  }
}

.ban-text {
  font-size: 50px;
  font-family: HuXiaoBo-NanShen;
  font-weight: 400;
  line-height: 54px;
  color: #ffffff;
  text-shadow: 0px 3px 8px rgba(194, 0, 0, 0.55);
  text-align: left;
  width: 1200px;
  margin: 0 auto;
  padding: 117px 70px 0 70px;
  box-sizing: border-box;

  img {
    width: 62px;
    height: auto;
    margin-left: 20px;
    vertical-align: middle;
  }

  span {
    font-size: 30px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
  }
}
.banner-style {
  background-size: 100% 100%;
  width: 100%;
  height: 260px;
  .img {
    width: 100%;
    height: 260px;
  }
}
.userHeader-wrap {
  width: 150px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 14px;
  &:hover {
    overflow: initial;
    background: rgba(225, 225, 225, 0.3);
    .icon-arrow {
      transform: rotate(180deg);
    }
    ul {
      width: auto;
      height: auto;
      z-index: 100;
      display: block;
      top: 60px;
      opacity: 1;
    }
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    color: #ccc;
  }
  ul {
    width: 0;
    height: 0;
    z-index: -100;
    overflow: hidden;
    transition-property: opacity, top;
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    opacity: 0;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
    li {
      cursor: pointer;
      background: #ffffff;
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #290202;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #f9f6f6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// layouts/defaultStatc.vue